import React, { useState } from "react";
import {
    Dialog,
    useMediaQuery,
    useTheme,
    Typography,
    Box,
    Divider,
    TextField,
    Button,
    Grid,
    FormControl,
    InputLabel,
    OutlinedInput,
    InputAdornment,
    IconButton,
    Radio,
    RadioGroup,
    FormControlLabel,
} from "@mui/material";
import { IoCloseCircleOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { getAllStudents, openAddStudentDialog } from "../Redux/Dashboard/DashboardSlice";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Spinner from "../Spinner/Spinner";
import { addStudent } from "../Redux/Auth/AuthSlice";
import { Notify } from "../CommonPopup/Popup";

const AddStudents = () => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const dispatch = useDispatch();
    const loader = useSelector((s) => s.DashboardSlice.loader);
    const open = useSelector((s) => s.DashboardSlice.showAddStudentDialog);

    const [formData, setFormData] = useState({
        email: "",
        name: "",
        password: "Judicial@1234",
        paid_account: false, // Default is unpaid
    });
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({
        email: false,
        name: false,
        password: false,
    });

    const handleClose = () => {
        dispatch(openAddStudentDialog(false));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: name === "email" ? value.toLowerCase() : value,
        });
    };

    const handlePaidAccountChange = (e) => {
        setFormData({
            ...formData,
            paid_account: e.target.value === "true", // convert to boolean
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isEmailValid = emailRegex.test(formData.email);

        const newErrors = {
            email: !formData.email || !isEmailValid,
            name: !formData.name,
            password: !formData.password,
        };

        setErrors(newErrors);

        if (!isEmailValid) {
            Notify({ data: "error", msg: "Enter a valid email address" });
            return;
        }

        if (!newErrors.email && !newErrors.name && !newErrors.password) {
            const adminData = {
                email: formData.email,
                name: formData.name,
                paid_account: formData.paid_account,
            };

            dispatch(addStudent(adminData))
                .unwrap()
                .then((data) => {
                    if (data?.success) {
                        Notify({ data: "success", msg: "Student added successfully" });
                        dispatch(openAddStudentDialog(false));
                        dispatch(getAllStudents());
                    } else {
                        Notify({ data: "error", msg: "Failed to add student" });
                    }
                })
                .catch((error) => {
                    Notify({ data: "error", msg: "Something went wrong!" });
                });
        }
    };


    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    p: 3,
                    bgcolor: "#fafafa",
                },
            }}
        >
            <Box>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h5" fontWeight="bold">
                        Add Student
                    </Typography>
                    <IoCloseCircleOutline
                        size={28}
                        onClick={handleClose}
                        style={{ cursor: "pointer", color: "#f44336" }}
                    />
                </Box>

                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Email"
                                variant="outlined"
                                fullWidth
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                error={errors.email}
                                helperText={
                                    errors.email &&
                                    (!formData.email
                                        ? "Email is required"
                                        : "Enter a valid email address")
                                }
                                required
                            />

                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField
                                label="Name"
                                variant="outlined"
                                fullWidth
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                error={errors.name}
                                helperText={errors.name && "name is required"}
                                required
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel>Password</InputLabel>
                                <OutlinedInput
                                    label="Password"
                                    name="password"
                                    disabled
                                    type={showPassword ? "text" : "password"}
                                    value={formData.password}
                                    onChange={handleChange}
                                    error={errors.password}
                                    required
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={togglePasswordVisibility}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <FormControl component="fieldset">
                                <RadioGroup
                                    row
                                    name="paid_account"
                                    value={formData.paid_account.toString()}
                                    onChange={handlePaidAccountChange}
                                >
                                    <FormControlLabel
                                        value="true"
                                        control={<Radio />}
                                        label="Paid Account"
                                    />
                                    <FormControlLabel
                                        value="false"
                                        control={<Radio />}
                                        label="Free Account"
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Box mt={2} display="flex" justifyContent="flex-end">
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            disabled={loader}
                        >
                            {loader ? <Spinner /> : "Add User"}
                        </Button>
                    </Box>
                </form>
            </Box>
        </Dialog>
    );
};

export default AddStudents;
